// This icon file is generated automatically.
var PWomanOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.14 7.57a4.41 4.41 0 000-6.27 4.41 4.41 0 00-6.28 0 4.41 4.41 0 00.42 6.65 4.4 4.4 0 002.13.89v1.66H4.62a.13.13 0 00-.12.13v.93c0 .07.06.13.13.13H6.4v2.19c0 .06.05.12.12.12h.94c.07 0 .12-.06.12-.13V11.7h1.79c.06 0 .12-.06.12-.13v-.94a.13.13 0 00-.13-.12H7.6V8.84a4.4 4.4 0 002.55-1.27zM7 7.7a3.23 3.23 0 01-3.25-3.25A3.23 3.23 0 017 1.19a3.23 3.23 0 013.25 3.25A3.23 3.23 0 017 7.69z", "fill-rule": "nonzero" } }] }, "name": "p-woman", "theme": "outlined" };
export default PWomanOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PWomanOutlined.js
// module id = 3734
// module chunks = 0